import { render, staticRenderFns } from "./hotel_item.vue?vue&type=template&id=aac4c804&scoped=true&"
import script from "./hotel_item.vue?vue&type=script&lang=ts&"
export * from "./hotel_item.vue?vue&type=script&lang=ts&"
import style0 from "./hotel_item.vue?vue&type=style&index=0&id=aac4c804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac4c804",
  null
  
)

export default component.exports